<template>
	<div id="app">
		<div class="RealnameAuthentication">
			<van-row span="24">
				<van-col span="24" class="RealnameAuthentication_T">带星号的为必填项，为了保证您的利益请如实填写</van-col>
				<!-- 必填条件 -->
				<van-col span="24" style="margin-top: 0.625rem;">
					<van-col span="24" class="RealnameAuthentication_B">
						<van-col span="11"   class="RealnameAuthentication_B_left">认证类型<img src="../assets/img/xing.png" alt=""></van-col>
						<van-col span="11" class="RealnameAuthentication_B_right" >请选择认证类型<van-icon name="arrow"/></van-col>
					</van-col>
					<van-col span="24" class="RealnameAuthentication_B">
						<van-col span="11"   class="RealnameAuthentication_B_left">真实姓名<img src="../assets/img/xing.png" alt=""></van-col>
						<van-col span="11" class="RealnameAuthentication_B_right" ><input type="text" placeholder="请输入您的真实姓名"></van-col>
					</van-col>
					<van-col span="24" class="RealnameAuthentication_B">
						<van-col span="11"   class="RealnameAuthentication_B_left">认证类型<img src="../assets/img/xing.png" alt=""></van-col>
						<van-col span="11" class="RealnameAuthentication_B_right" ><input type="text" placeholder="请输入您的联系方式"></van-col>
					</van-col>
				</van-col>
				<!-- 上传身份证照片 -->
				<van-col span="24" class="RealnameAuthentication_photo">
					<van-col span="24" class="RealnameAuthentication_photo_T">上传身份证照片</van-col>
					<van-col span="24" class="RealnameAuthentication_photo_Top">
						<van-col span="11">
							<img src="../assets/img/photoZ.png" alt="" class="RealnameAuthentication_photo_Z">
							<span class="RealnameAuthentication_photo_C">请上传身份证正面</span>
						</van-col>
						<van-col  span="11">
							<img src="../assets/img/photob.png" alt="" class="RealnameAuthentication_photo_Z">
							<span class="RealnameAuthentication_photo_C">请上传身份证反面</span>
						</van-col>
					</van-col>
					<van-col span="24"  class="RealnameAuthentication_photo_Top">
						<van-col span="11">
							<img src="../assets/img/photoS.png" alt="" class="RealnameAuthentication_photo_Z">
							<span class="RealnameAuthentication_photo_C">请上传手持身份证照片</span>
						</van-col>
						<van-col  span="11">
							<img src="../assets/img/photoN.png" alt="" class="RealnameAuthentication_photo_Z">
							<span class="RealnameAuthentication_photo_C" style="color:#FF5400; margin-left: 4.0625rem;">手持身份证示例</span>
						</van-col>
					</van-col>
				</van-col>
				<!-- 提交按钮 -->
				<van-col class="RealnameAuthenticationBtn">立即提交</van-col>
			</van-row>
		</div>
	</div>
</template>

<script>
	 import '@/assets/css/style.css'
	import axios from 'axios'
	import Toast from "vant/lib/toast"
	import { Icon } from 'vant';
	export default {
	    data() {
	        return {

			    }
		  }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RealnameAuthentication.vue